import React, { useState } from 'react';
import Modal from '../../../components/Modal';
import ReactTooltip from 'react-tooltip';
import { downloadFile } from '../../../common/download';
import { Context } from '../../../config/store';
import LenderUgroService from '../../../services/lender';
import message from '../../../constant/message';
import { toast } from 'react-toastify';
import RenderFile from '../../../pages/OnboardingForm/RenderFile';
import MasterDataService from '../../../services/master-data';
import { useParams } from 'react-router';

const ViewFile = ({ row: { file_id, doc_type } }) => {
	const { state } = React.useContext(Context);
	const [modalState, setModalState] = React.useState(false);
	const [fileUrl, setFileUrl] = React.useState('');
	const [loading, setState] = React.useState(false);
	const [showTooltip, setShowTooltip] = React.useState(false)
	const toggleModal = () => {
		setModalState(!modalState);
		if (!matchMedia) setFileUrl('');
	};
	const viewFile = async () => {
		setTimeout(() => setShowTooltip(false), 50);
		setState(true);
		try {
			const response = await LenderUgroService.downloadDocFile(
				state.userType,
				state.userType === 'admin' ? 'co-lender' : '',
				file_id
			);

			let url = window.URL.createObjectURL(response.data);
			setFileUrl(url);
			toggleModal();
		} catch (err) {
			toast.error(message.ERROR);
		}
		setState(false);
	};
	return (
		<>
			<Modal
				state={modalState}
				closeModal={toggleModal}
				removeBorderSpace={true}
				style={fileUrl && { width: '70%', height: '80%' }}
			>
				{!fileUrl ? (
					'No file to view'
				) : (
					<RenderFile
						extension={(String(doc_type) || '').split('/')?.[1] || doc_type}
						fileUrl={fileUrl}
						closeModal={toggleModal}
					/>
				)}
			</Modal>
			{showTooltip && <ReactTooltip id='view-file'>View Document</ReactTooltip>}
			<div
				type='button'
				className='mr-2'
				onClick={viewFile}
				disabled={loading}
				data-tip
				data-for='view-file'
				style={{ cursor: 'pointer' }}
				onMouseEnter={() => {
					setShowTooltip(true)
				}}
				onMouseLeave={() => {
					setShowTooltip(false);
				}}
			>
				{loading ? <div className='loader' /> : <i className='fa fa-eye fa-lg' style={{ color: '#4A4E88' }}></i>}
			</div>
		</>
	);
};
const DocumentDownload = ({
	row,
	reloadTable,
	selectedLender,
	selectedLenderName,
	documentName,
	documentValue,
	coapplicants,
	scoreInput,
}) => {
	const [showBankPasswordModal, setShowBankPasswordModal] =
		React.useState(false);
	const [bankPasswordModalType, setBankPasswordModalType] =
		React.useState(null);
	const [bankPasswordModalInputValue, setBankPasswordModalInputValue] =
		React.useState('');
	const [updatingPassword, setUpdatingPassword] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const { state } = React.useContext(Context);
	const [bankNames, setBankNames] = React.useState([])
	const [accountName, setAccountName] = React.useState('')
	const [accountType, setAccountType] = React.useState('')
	const [iFSC, setIFSC] = React.useState('')
	const [accountNumber, setAccountNumber] = React.useState('')
	const [selectedBankName, setSelectedBankName] = React.useState('')
	const [odccLimit, setOdccLimit] = React.useState('')
	const [reportType, setreportType] = useState('')
	const [applicant, setapplicant] = useState('')
	const [panNo, setpanNo] = useState('')
	const [bureauReportType, setBureauReportType] = useState('')
	const [bureauApplicant, setBureauApplicant] = useState('')
	const [bureauPanNo, setBureauPanNo] = useState('')
	const [score, setScore] = useState('')
	const [refNumber, SetRefNumber] = useState('')
	const [applicant_type, setapplicant_type] = useState([])
	const [account_type, setAccount_type] = useState([])
	const [bankId, setBankid] = useState('')
	const [error, setError] = useState({})
	const leadId = useParams().id;
	const [annualTurnover, setAnnualTurnover] = useState('')
	const [selectedBussinessSector, setSelectedBusinessSector] = useState('')
	const [selectedBussinessSubSector, setSelectedBusinessSubSector] = useState('')
	const [selectedIndustryType, setSelectedIndustryType] = useState('')
	const [selectedSubIndustryType, setSelectedSubIndustryType] = useState('')
	const [bussinessSectors, setBusinessSectors] = useState([])
	const [bussinessSubSectors, setBusinessSubSectors] = useState([])
	const [industryTypes, setIndustryTypes] = useState([])
	const [subIndustryTypes, setSubIndustryTypes] = useState([])
	const [subIndustryTypes2, setSubIndustryTypes2] = useState([])

	React.useEffect(() => {
		// getBankNameList()
		getBankdata()
	}, [showBankPasswordModal])

	React.useEffect(() => {
		setSubIndustryManually(selectedIndustryType)
	}, [subIndustryTypes2])

	const getBankdata = () => {
		let data = JSON.parse(row?.bank_info)
		let reportInfo = JSON.parse(row?.report_info)
		let leadDocInfo = JSON.parse(row?.lead_doc_info)
		setAccountName(data?.account_holder_name)
		setAccountType(data?.account_type)
		setBankid(data?.bank_id)
		// setIFSC(data?.ifsc)
		setAccountNumber(data?.account_number)
		setSelectedBankName(data?.bank_id)
		if (data?.odcc_limit === 'null') {
			setOdccLimit('')
		} else {
			setOdccLimit(data?.odcc_limit)
		}
		setpanNo(reportInfo?.pan_no)
		setreportType(reportInfo?.report_type)
		setapplicant(reportInfo?.applicant_type)
		setBureauPanNo(reportInfo?.pan_no)
		setBureauReportType(reportInfo?.report_type)
		setBureauApplicant(reportInfo?.applicant_type)
		setScore(reportInfo?.score)
		SetRefNumber(leadDocInfo?.RefNumber)
		setSelectedBusinessSector(leadDocInfo?.business_sector)
		setAnnualTurnover(leadDocInfo?.annual_turnover)
		setSelectedIndustryType(leadDocInfo?.industry_type)
		setSelectedSubIndustryType(leadDocInfo?.sub_industry_type)
		setSelectedBusinessSubSector(leadDocInfo?.business_sub_sector)
	}

	const setSubIndustryManually = (ind) => {
		let sub_ind_org = [];
		let sub_ind = [];
		for(const { id, name, sub_industry } of subIndustryTypes2){
			if(name == ind){
				sub_ind_org = sub_industry;
				break;
			}
		}
		for(const { id, name } of sub_ind_org){
			sub_ind.push({ id: name, value: name })
		}
		setSubIndustryTypes(sub_ind)
	}
	const getBankNameList = async () => {
		const response = await MasterDataService.getDocumentList(
			state.userType,
			'co-lender',
			leadId,
			selectedLender
		);
		let applicant_data_type = response?.data?.data?.applicant_type ?? {}
		let account_data_type = response?.data?.data?.account_type ?? {}
		let business_sector_type = response?.data?.data?.business_sector ?? {}
		let business_sub_sector_type = response?.data?.data?.business_sub_sector ?? {}
		let industry_type = response?.data?.data?.industry_type ?? {}
		let sub_industry_type = response?.data?.data?.sub_industry_type ?? []

		let account_data = []
		for (const [key, value] of Object.entries(account_data_type)) {
			account_data.push({ id: key, value })
		}
		setAccount_type(account_data)

		let applicant_data = []
		for (const [key, value] of Object.entries(applicant_data_type)) {
			applicant_data.push({ id: key, value })
		}
		setapplicant_type(applicant_data)

		let data = response?.data?.data?.bank_types
		let finaldata = []
		for (const [key, value] of Object.entries(data)) {
			finaldata.push({ id: key, value })
		}
		setBankNames(finaldata);

		let business_sector = []
		for (const [key, value] of Object.entries(business_sector_type)) {
			business_sector.push({ id: key, value })
		}
		setBusinessSectors(business_sector)

		let business_sub_sector = []
		for (const [key, value] of Object.entries(business_sub_sector_type)) {
			business_sub_sector.push({ id: key, value })
		}
		setBusinessSubSectors(business_sub_sector)

		let industry = []
		for (const [key, value] of Object.entries(industry_type)) {
			industry.push({ id: key, value })
		}
		setIndustryTypes(industry)
		setSubIndustryTypes2(sub_industry_type)
		setSubIndustryManually(selectedIndustryType)
		// let sub_industry = []
		// for (const [key, value] of Object.entries(sub_industry_type)) {
		// 	sub_industry.push({ id: key, value })
		// }
		// setSubIndustryTypes(sub_industry)
	}

	const showEditPasswordModal = () => {
		getBankNameList()
		setBankPasswordModalType('Edit');
		setError({})
		setShowBankPasswordModal(true);
	};

	const viewableSelectedLender = () => {
		return (
			typeof row?.for_lenders === 'string'
				? JSON.parse(row.for_lenders)
				: row?.for_lenders || []
		).some((lender) => lender === selectedLender);
	};
	const [isChecked, setCheckStatus] = React.useState(
		viewableSelectedLender() || false
	);
	const showViewPasswordModal = () => {
		setBankPasswordModalType('View');
		setShowBankPasswordModal(true);
	};
	React.useEffect(() => {
		if (accountType !== 'OverDraft') {
			setOdccLimit('');
		} else {
			let data = JSON.parse(row?.bank_info)
			if (data?.odcc_limit === 'null') {
				setOdccLimit('')
			} else {
				setOdccLimit(data?.odcc_limit)
			}
		}
	}, [accountType]);
	React.useEffect(() => {
		setBankPasswordModalInputValue(row.password);
	}, []);
	React.useEffect(() => {
		setCheckStatus(viewableSelectedLender());
	}, [selectedLender]);
	const downloadDoc = async () => {
		setLoading(true);
		try {
			const response = await LenderUgroService.downloadDocFile(
				state.userType,
				state.userType === 'admin' ? 'co-lender' : '',
				row.lead_doc_file_id
			);
			downloadFile(response?.data, row?.alias_name ? row?.alias_name : `${row?.file_name}`);
		} catch (err) {
			toast.error(message.ERROR);
		}
		setLoading(false);
	};

	const updateBankPasswordModalValue = async (type) => {
		setUpdatingPassword(true);
		setError({})
		try {
			
			if (type === "Bank Statement") {
				const response = await LenderUgroService.updateDocPassword(
					state.userType,
					{
						lead_doc_file_id: row.lead_doc_file_id,
						doc_password: bankPasswordModalInputValue,
						bank_id: selectedBankName,
						account_holder_name: accountName,
						account_type: accountType,
						account_number: accountNumber,
						// ifsc: iFSC,
						odcc_limit: accountType === "OverDraft" ? odccLimit : '',
						doc_type: type
					},
					state.userType === 'admin' ? 'co-lender' : null
				);
				const success = response?.data?.messages?.success;
				toast.success(
					success?.form?.[0] ||
					success?.others?.[0] ||
					'Password' + message.UPDATE_SUCCESS
				);
				if (response?.data?.status?.code == 1) {
					setUpdatingPassword(false);
					reloadTable();
					setShowBankPasswordModal(false);
				}
			}
			else if (type === "Banking Excel") {
				{
					const response = await LenderUgroService.updateDocPassword(
						state.userType,
						{
							lead_doc_file_id: row.lead_doc_file_id,
							doc_password: bankPasswordModalInputValue,
							bank_id: selectedBankName,
							doc_type: type
						},
						state.userType === 'admin' ? 'co-lender' : null
					);
					const success = response?.data?.messages?.success;
					toast.success(
						success?.form?.[0] ||
						success?.others?.[0] ||
						'Password' + message.UPDATE_SUCCESS
					);
					if (response?.data?.status?.code == 1) {
						setUpdatingPassword(false);
						reloadTable();
						setShowBankPasswordModal(false);
					}
				}
			}
			else if (type === "CIBIL Report") {
				const response = await LenderUgroService.reportInfoUpdate(
					state.userType,
					{
						lead_doc_file_id: row.lead_doc_file_id,
						report_type: reportType,
						account_type: applicant,
						pan_no: panNo,
						lender_id: selectedLender,
						cl_lead_id: leadId,
						// score: score,
						// CMRRank: CMRrank,
					},
					state.userType === 'admin' ? 'co-lender' : null
				);
				const success = response?.data?.messages?.success;
				toast.success(
					success?.form?.[0] ||
					success?.others?.[0] ||
					'Password' + message.UPDATE_SUCCESS
				);
				if (response?.data?.status?.code == 1) {
					setUpdatingPassword(false);
					reloadTable();
					setShowBankPasswordModal(false);
				}
			}
			else if (type === "Bureau Report") {
				const response = await LenderUgroService.reportInfoUpdate(
					state.userType,
					{
						lead_doc_file_id: row.lead_doc_file_id,
						report_type: bureauReportType,
						account_type: bureauApplicant,
						pan_no: bureauPanNo,
						lender_id: selectedLender,
						cl_lead_id: leadId,
						score: score,
						// CMRRank: CMRrank,
					},
					state.userType === 'admin' ? 'co-lender' : null,

				);
				const success = response?.data?.messages?.success;
				toast.success(
					success?.form?.[0] ||
					success?.others?.[0] ||
					'Password' + message.UPDATE_SUCCESS
				);
				if (response?.data?.status?.code == 1) {
					setUpdatingPassword(false);
					reloadTable();
					setShowBankPasswordModal(false);
				}
			}
			else if ((documentValue?.document?.lead_type_show && documentValue?.document?.is_update == 1) || (documentValue?.document?.is_update == 1)) {
				const response = await LenderUgroService.reportInfoUpdate(
					state.userType,
					{
						lead_doc_file_id: row.lead_doc_file_id,
						RefNumber: refNumber,
						...(documentValue?.is_business_sector == 1 && {business_sector: selectedBussinessSector}),
						...(documentValue?.is_anual_turnover == 1 && {annual_turnover: annualTurnover}),
						...(documentValue?.is_business_sub_sector == 1 && {business_sub_sector: selectedBussinessSubSector}),
						...(documentValue?.is_industry_type == 1 && {industry_type: selectedIndustryType}),
						...(documentValue?.is_sub_industry_type == 1 && {sub_industry_type: selectedSubIndustryType}),
						lender_id: selectedLender,
						cl_lead_id: leadId
					},
					state.userType === 'admin' ? 'co-lender' : null
				);
				const success = response?.data?.messages?.success;
				toast.success(
					success?.form?.[0] ||
					success?.others?.[0] ||
					'Password' + message.UPDATE_SUCCESS
				);
				if (response?.data?.status?.code == 1) {
					setUpdatingPassword(false);
					reloadTable();
					setShowBankPasswordModal(false);
				}
			}
		} catch (err) {
			// reloadTable();
			// setUpdatingPassword(false);
			let error = err?.response?.data?.messages?.error;
			setError(error)
			toast.error(
				error?.form?.[0] ||
				error?.others?.[0]
			);
			setShowBankPasswordModal(true);
		}


	};

	const toggleDocumentVisibilityForLender = async () => {
		setCheckStatus(!isChecked);
		try {
			const response = await LenderUgroService.toggleDocumentForLender(
				state.userType,
				state.userType === 'admin' ? 'co-lender' : null,
				{
					doc_lender_updates: [{ [row.lead_doc_file_id]: !isChecked ? 1 : 0 }],
					lender_id: selectedLender,
				}
			);
			const success = response?.data?.messages?.success;
			toast.success(
				success?.form?.[0] || success?.others?.[0] || message.UPDATE_SUCCESS
			);
			setUpdatingPassword(false);
			reloadTable();
			setShowBankPasswordModal(false);
		} catch (err) {
			reloadTable();
			setUpdatingPassword(false);
			let error = err?.response?.data?.messages?.error;
			toast.error(
				error?.fields?.doc_password?.[0] ||
				error?.form?.[0] ||
				error?.others?.[0] ||
				message.ERROR_FORM
			);
			setShowBankPasswordModal(false);
		}
	};

	const checkHasPermission = (checkPermission) => {
		if (state.is_super_admin === 1) return true;
		const permission = state.permission.find(
			(permission) => permission === checkPermission
		);

		if (permission) return true;
		else return false;
	};

	return (
		<div className='d-flex align-items-center justify-content-between'>
			<ReactTooltip id='download-document'>Download Document</ReactTooltip>
			<div
				className='mr-2'
				onClick={downloadDoc}
				disabled={loading}
				data-tip
				data-for='download-document'
			>
				{loading ? <div className='loader' /> : <span style={{ cursor: 'pointer' }}><i class="fa fa-cloud-download fa-lg" style={{ color: '#4A4E88' }} aria-hidden="true"></i></span>}
			</div>
			<div>
				{' '}
				<ReactTooltip id='viewable-current-lender'>
					{isChecked ? 'Visible' : 'Not visible'} to {selectedLenderName}
				</ReactTooltip>
			</div>
			<ViewFile
				row={{ doc_type: row.mime_type, file_id: row.lead_doc_file_id }}
			/>
			{/* {console.log(documentList.id, documentList?.value[0]?.document?.is_update)} */}
			{checkHasPermission('document-submit-to-lender') && <div className='d-flex'>
				<ReactTooltip id='view-password'>View Password</ReactTooltip>
				<ReactTooltip id='edit-password'>Edit Document</ReactTooltip>
				{(((documentValue?.document?.lead_type_show == 1 || documentValue?.document?.lead_type_show == 2) && documentValue?.document?.is_update == 1 && documentValue?.document?.is_ref == 1)) ? <>{(
					<div
						className=''
						data-tip
						data-for='edit-password'
						onClick={showEditPasswordModal}
						style={{ cursor: 'pointer' }}
					>
						<i className='fa fa-pencil fa-lg' style={{ color: '#4A4E88' }}></i>
					</div>
				)}</> : <>
					{(documentName === "Bank Statement" || documentName === "Banking Excel") && (
						<>
							<div
								className='mr-2'
								data-tip
								data-for='view-password'
								onClick={showViewPasswordModal}
								style={{ cursor: 'pointer' }}
							>
								<i className='fa fa-info-circle fa-lg' style={{ color: '#4A4E88' }}></i>
							</div>
							<div
								className=''
								data-tip
								data-for='edit-password'
								onClick={showEditPasswordModal}
								style={{ cursor: 'pointer' }}
							>
								<i className='fa fa-pencil fa-lg' style={{ color: '#4A4E88' }}></i>
							</div>

						</>
					)}
					{(documentName === "CIBIL Report" || documentName === "Bureau Report" || documentName === "Co-Applicant GST Certificate" || documentName === "Co-Applicant UDYAM Certificate") && (
						<>
							<div
								className=''
								data-tip
								data-for='edit-password'
								onClick={showEditPasswordModal}
								style={{ cursor: 'pointer' }}
							>
								<i className='fa fa-pencil fa-lg' style={{ color: '#4A4E88' }}></i>
							</div>

						</>
					)}
				</>}
			</div>}

			<Modal
				state={showBankPasswordModal}
				closeModal={() => setShowBankPasswordModal(false)}
				style={{ width: "450px" }}
				removeBorderSpace={true}
			>

				<div className=''>
					{bankPasswordModalType === 'View' ? (
						<div>
							<div className="modal-header-container">
								<div className="modal-title">Document Password</div>
								<div className="closeModalView" onClick={() => setShowBankPasswordModal(false)}>
									<span className="closeModalIcon">x</span>
								</div>
							</div>
							<div className='p-4 modalData text-center'>
								<p>
									{row.password?.trim() ? (
										<span>
											Password for document is <b>{row.password}</b>
										</span>
									) : (
										'No password set for this document'
									)}
								</p>
								<div className="col-12 d-flex justify-content-center mt-3">
									<button
										className='btn btn-custom'
										onClick={() => setShowBankPasswordModal(false)}
									>
										OK
									</button>
								</div>
							</div>
						</div>
					) : (
						<div className=''>
							<div className="modal-header-container mb-2">
								<div className="modal-title">{documentName}</div>
								<div className="closeModalView" onClick={() => setShowBankPasswordModal(false)}>
									<span className="closeModalIcon">x</span>
								</div>
							</div>
							{documentName === "Bank Statement" &&
								<div>

									<div className='px-4 pt-4 modalData'>
										<div className=''>
											<lebal>Account Holder Name</lebal>
											<input
												type='text'
												className='form-control'
												onChange={(e) => setAccountName(e.target.value)}
												value={accountName}
												placeholder=''
												maxlength={50}
											></input>
										</div>
										<tt>{error?.fields?.account_holder_name?.[0]}</tt>
										<div className=''>
											<lebal>Account Type</lebal>
											<select className='form-control' value={accountType} onChange={(e) => { setAccountType(e.target.value) }}>
												<option value='' >Select</option>
												{account_type && account_type.map(({ id, value }) => {
													return (
														<option value={id}>{value}</option>
													)
												})}
											</select>
										</div>
										<tt>{error?.fields?.account_type?.[0]}</tt>
										{(accountType === "OverDraft") &&
											<>
												<div className='mb-2'>
													<lebal>ODCC limit</lebal>
													<input
														type='text'
														className='form-control'
														onChange={(e) => setOdccLimit(e.target.value.replace(/[^0-9.]/g, ''))}
														value={odccLimit}
														placeholder=''
														maxlength={20}
													></input>
												</div>
												<tt>{error?.fields?.odcc_limit?.[0]}</tt>
											</>
										}

										<div className=''>
											<lebal>Account Number</lebal>
											<input
												type='text'
												className='form-control'
												onChange={(e) => setAccountNumber(e.target.value)}
												value={accountNumber}
												placeholder=''
												maxlength={50}
											></input>
										</div>
										<tt>{error?.fields?.account_number?.[0]}</tt>
										<div className=''>
											<lebal>Bank Name</lebal>
											<select className='form-control' value={selectedBankName} onChange={(e) => { setSelectedBankName(e.target.value) }}>
												<option value={''}>select </option>
												{bankNames && bankNames.map((bank) => {
													return (
														<option value={bank?.id}>{bank?.value}</option>
													)
												})}
											</select>
										</div>
										<tt>{error?.fields?.bank_id?.[0]}</tt>
									</div>
								</div>
							}
							{(documentName === "Bank Statement" || documentName === "Banking Excel") &&
								<div className='px-4 modalData'>
									<lebal>	Edit Password</lebal>
									<br />
									<lebal style={{ fontSize: "10px" }} className="text-orange">(Note: Please enter password only if the document is password protected.)</lebal>
									<input
										type='text'
										className='form-control'
										onChange={(e) => setBankPasswordModalInputValue(e.target.value)}
										value={bankPasswordModalInputValue}
										placeholder=''
										maxlength={25}
									></input>
									<tt>{error?.fields?.doc_password?.[0]}</tt>
								</div>
							}
							{documentName === "CIBIL Report" && <>
								<div className='px-4 pt-4 modalData'>
									<div className=''>
										<lebal>Report Type</lebal>
										<select className='form-control' value={reportType} onChange={(e) => setreportType(e.target.value)}>
											<option value='' >Select</option>
											<option value={"Commercial"}>Commercial</option>
											<option value={"Consumer"}>Consumer</option>
										</select>
										<tt>{error?.fields?.report_type?.[0]}</tt>
									</div>
									<div className=''>
										<lebal>Applicant Type</lebal>
										<select className='form-control' value={applicant} onChange={(e) => { setapplicant(e.target.value) }}>
											<option value='' >Select</option>
											{applicant_type && applicant_type.map(({ id, value }) => {
												return (
													<option value={id}>{value}</option>
												)
											})}
										</select>
										<tt>{error?.fields?.account_type?.[0]}</tt>
									</div>
									<div className=''>
										<lebal>Pan No</lebal>
										<input
											type='text'
											className='form-control'
											onChange={(e) => setpanNo(e.target.value)}
											value={panNo}
											placeholder=''
											maxlength={10}
										></input>
										<tt>{error?.fields?.pan_no?.[0]}</tt>
									</div>
								</div>
							</>}
							{documentName === "Bureau Report" && <>
								<div className="px-4 pt-4  modalData">
									<div className=''>
										<lebal>Report Type</lebal>
										<select className='form-control' value={bureauReportType} onChange={(e) => setBureauReportType(e.target.value)}>
											<option value=''>Select</option>
											<option value={"Commercial"}>Commercial</option>
											<option value={"Consumer"}>Consumer</option>

										</select>
										<tt>{error?.fields?.report_type?.[0]}</tt>
									</div>
									<div className=''>
										<lebal>Applicant Type</lebal>
										<select className='form-control' value={bureauApplicant} onChange={(e) => { setBureauApplicant(e.target.value) }}>
											<option value=''>Select</option>
											{applicant_type && applicant_type.map(({ id, value }) => {
												return (
													<option value={id}>{value}</option>
												)
											})}
										</select>
										<tt>{error?.fields?.account_type?.[0]}</tt>
									</div>
									{!(scoreInput && selectedLender == 3 && row?.cl_coapplicant_id && !coapplicants?.[row?.cl_coapplicant_id]) &&
									<div className=''>
										<lebal>PAN</lebal>
										<input
											type='text'
											className='form-control'
											onChange={(e) => setBureauPanNo(e.target.value)}
											value={bureauPanNo}
											placeholder=''
											style={{'text-transform': 'uppercase'}}
											maxlength={10}
										></input>
										<tt>{error?.fields?.pan_no?.[0]}</tt>
									</div>}
									{scoreInput && selectedLender == 3 && row?.cl_coapplicant_id && !coapplicants?.[row?.cl_coapplicant_id] && 
									<div className=''>
										<lebal>Bureau Score</lebal>
										<input
											type='number'
											className='form-control'
											onChange={(e) => setScore(e.target.value)}
											value={score}
											maxLength={3}
											placeholder=''
										></input>
										<tt>{error?.fields?.score?.[0]}</tt>
									</div>}
								</div>
							</>}
							{documentValue?.document?.is_ref == 1 && <div className='px-4'>
								<lebal> Reference Number </lebal>
								<input
									type='text'
									className='form-control'
									onChange={(e) => SetRefNumber(e.target.value)}
									value={refNumber}
									maxlength={50}
									style={{'text-transform': 'uppercase'}}
								></input>
								<tt>{error?.fields?.RefNumber?.[0]}</tt>
							</div>}
							{documentValue?.is_anual_turnover == 1 && documentName === "Co-Applicant GST Certificate" && <div className="px-4">
								<lebal>Annual Turnover</lebal>
								<input
									type='text'
									className='form-control'
									onChange={(e) => setAnnualTurnover(e.target.value.replace(/[^0-9.]/g, ''))}
									value={annualTurnover}
									placeholder=''
									maxlength={20}
								></input>
								<tt>{error?.fields?.annual_turnover?.[0]}</tt>
							</div>}
							{documentValue?.is_industry_type == 1 && (documentName === "Co-Applicant GST Certificate" || documentName === "Co-Applicant UDYAM Certificate") && <div className="px-4">
								<lebal>Industry Type</lebal>
								<select className='form-control' value={selectedIndustryType} onChange={(e) => { setSubIndustryManually(e.target.value); setSelectedIndustryType(e.target.value) }}>
									<option value=''>Select</option>
									{industryTypes && industryTypes.map(({ id, value }) => {
										return (
											<option value={id}>{value}</option>
										)
									})}
								</select>
								<tt>{error?.fields?.industry_type?.[0]}</tt>
							</div>}
							{documentValue?.is_sub_industry_type == 1 && (documentName === "Co-Applicant GST Certificate" || documentName === "Co-Applicant UDYAM Certificate") && <div className="px-4">
								<lebal>Sub Industry Type</lebal>
								<select className='form-control' value={selectedSubIndustryType} onChange={(e) => { setSelectedSubIndustryType(e.target.value) }}>
									<option value=''>Select</option>
									{subIndustryTypes && subIndustryTypes.map(({ id, value }) => {
										return (
											<option value={id}>{value}</option>
										)
									})}
								</select>
								<tt>{error?.fields?.sub_industry_type?.[0]}</tt>
							</div>}
							{documentValue?.is_business_sector == 1 && documentName === "Co-Applicant GST Certificate" && <div className="px-4 mb-1">
								<lebal>Business Sector</lebal>
								<select className='form-control' value={selectedBussinessSector} onChange={(e) => { setSelectedBusinessSector(e.target.value) }}>
									<option value=''>Select</option>
									{bussinessSectors && bussinessSectors.map(({ id, value }) => {
										return (
											<option value={id}>{value}</option>
										)
									})}
								</select>
								<tt>{error?.fields?.business_sector?.[0]}</tt>
							</div>}
							{documentValue?.is_business_sub_sector == 1 && documentName === "Co-Applicant GST Certificate" && <div className="px-4">
								<lebal>Business Sub Sector</lebal>
								<select className='form-control' value={selectedBussinessSubSector} onChange={(e) => { setSelectedBusinessSubSector(e.target.value) }}>
									<option value=''>Select</option>
									{bussinessSubSectors && bussinessSubSectors.map(({ id, value }) => {
										return (
											<option value={id}>{value}</option>
										)
									})}
								</select>
								<tt>{error?.fields?.business_sub_sector?.[0]}</tt>
							</div>}
							
							<div className='d-flex align-items-center justify-content-center my-3'>
								<button
									className='btn btn-custom mr-1'
									onClick={() => updateBankPasswordModalValue(documentName)}
								>
									{'Update'}
								</button>
								<button
									className='btn btn-outline-custom'
									onClick={() => setShowBankPasswordModal(false)}
								>
									Close
								</button>
							</div>
						</div>
					)
					}
				</div >
			</Modal >
		</div >
	);
};

export default DocumentDownload;
